import React from 'react';

import { useNHDProvidersOptions } from '../../../hooks/domain/nhd/useNHDProviders';
import useGetUserSettingsQuery from '../../../hooks/domain/user/queries/useGetUserSettingsQuery';
import { useFeatureFlags } from '../../../hooks/useFeatureFlags';

import type { IntegrationState } from './types';
import { useHasShown } from './useHasShown';

export const useShowNHDUserPreferenceMissingDialog = (): IntegrationState => {
  const userSettings = useGetUserSettingsQuery();
  const nhdProviders = useNHDProvidersOptions();
  const { formsNhdIntegration } = useFeatureFlags();

  const isLoading = userSettings.isLoading || nhdProviders.isLoading;
  const show = React.useMemo(
    () =>
      Boolean(
        !isLoading &&
          userSettings.data &&
          userSettings.data.isInitialized &&
          userSettings.data.userPreferences?.nhdProviderPreference == null &&
          nhdProviders.data &&
          nhdProviders.data.length > 1 &&
          formsNhdIntegration
      ),
    [isLoading, userSettings.data, nhdProviders.data, formsNhdIntegration]
  );
  const hasShown = useHasShown(show);

  return { show, hasShown, isLoading };
};
